import { parseISO } from 'date-fns/parseISO';
import { format } from 'date-fns/format';
import { isValid } from 'date-fns/isValid';
import { tz } from '@date-fns/tz';

import useLazySSR from './useLazySSR';

/**
 * Format the ISO date string using the given date format
 * Initial render from server will appear in UTC (with an annotation that it is UTC)
 * Then it will update to the client's timezone
 */
const useFormattedDate = (dateString, dateFormat, overrideClientTimezone = undefined) => {
  const formatted = useLazySSR((ssr) => {
    if (!dateString) return dateString;
    const parsed = parseISO(dateString, { in: ssr ? tz('Etc/UTC') : overrideClientTimezone });
    if (!isValid(parsed)) return '';
    return format(parsed, ssr ? `${dateFormat} 'UTC'` : dateFormat);
  }, [dateString, dateFormat, overrideClientTimezone]);
  return formatted;
};

export default useFormattedDate;
